<template>
  <div>
    Timeline Page
  </div>
</template>

<script>
export default {
  name: 'Timeline',
  created () {

  }
}
</script>



// WEBPACK FOOTER //
// Timeline.vue?7eb11ef8